import React from "react";
import { Card } from "antd";
import { LucideAward, LucideSparkles } from "lucide-react";


const EmployeeScoreCard = ( props ) => {
  const { earnedPoints = 0, grandTotal = 800 } = props;

const thresholds = [
    { label: "Exceeds", min: grandTotal - 125 + 1 },
    { label: "Meets", min: grandTotal - 250 + 1 },
    { label: "Needs improvement", min: grandTotal - 375 + 1 },
    { label: "Does not meet expectations", min: 0 },
  ];

const scaleMap = {
  "Does not meet expectations": "Needs Focus",
  "Needs improvement": "Developing",
  "Meets": "Meets",
  "Exceeds": "Exceeds",
};

const getStatusClass = (scale) =>
  (scaleMap[scale] || "")
    .toLowerCase()
    .replace(/\s+/g, "-");



const overallResult = thresholds.find(t => earnedPoints >= t.min)?.label || "Does not meet expectations";


  
  return (
    <div className="space-y-6">
      <Card className="text-card-foreground flex flex-col gap-6 rounded-xl border-2 border-purple-200  gradient pink">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-xl shadow-md gradient purple">
                  <LucideAward 
                    className="text-white"
                    size={24}
                  />
              </div>
              <div className="flex items-start flex-col">
                <p className="text-[13px] text-gray-700 mb-1">Overall Performance Rating</p>
                <span className={`status-indicator ${getStatusClass(overallResult)}`}>
                  {overallResult}
                </span>
              </div>
            </div>
            <div className="flex">
                <LucideSparkles
                  className="text-purple-400"
                  size={32}
                />
            </div>
          </div>
      </Card>
    </div>


);
};

export default EmployeeScoreCard;